import * as React from "react";
import * as logoUrl from "./images/logo.png";

export function App() {
  return (
    <img
      src={logoUrl}
      style={{
        width: 288,
        height: 253,
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -126,
        marginLeft: -144,
      }}
    />
  );
}



// WEBPACK FOOTER //
// ./src/App.tsx